import React, { useEffect, useState } from 'react';
import { StandaloneStructService } from 'ketcher-standalone';
import { Ketcher } from 'ketcher-core';
import './SmilesComponent.css';

const structServiceProvider = new StandaloneStructService();
const ketcher = new Ketcher({}, structServiceProvider, {});

const SmilesComponent = ({ smiles }) => {
  const [imgLink, setImgLink] = useState('');

  useEffect(() => {
    
    ketcher.generateImage(smiles, {

      outputFormat: 'svg',
      backgroundColor: "255, 255, 255"
    }).then((res) => {
      const url = window.URL.createObjectURL(res);
      setImgLink(url);
      console.log("success")
    });
  }, [smiles]);

  return (
    <div className="SmilesComponent">
      <img src={imgLink} alt='SMILES' />
      <div className="smiles-string">
        {smiles}
      </div>
    </div>
  );
};

export default SmilesComponent;
